import uuidv4 from 'uuid/v4'
export default class Event {
    constructor() {
        this._title // The display title for the event
        this._startDate // a moment.js object
        this._data = {}// javascript object for passing any additional data
        this._endDate // a momemt.js object
        this.id = uuidv4() // a unique identifier
        this.duration = 60 // a momemt.duration() object 60 minutes by default
        this.viewComponents = []
        this.style = ''
        this.fixed = false
        this.type = 'No Type'
    }

    get title() {
        return this._title
    }
    
    set title(title) {
        if (typeof title !== "string") {
            throw Error('title must be a string!')
        }
        this._title = title
    }

    get type() {
        return this._type
    }
    
    set type(type) {
        if (typeof type !== "string") {
            throw Error('type must be a string!')
        }
        this._type = type
    }
    
    get startDate() {
        return this._startDate ? this._startDate.clone() : undefined
    }

    set startDate(startDate) {
        if (!moment.isMoment(startDate) || !startDate.isValid()) {
            throw Error(startDate + ' is not a valid moment instance!')
        }
        this._startDate = startDate.clone()
    }

    get data() {
        return this._data
    }

    set data(data) {
        this._data = data
    }

    get duration() {
        // by default returns duration in minutes
        return this._duration ? this._duration.asMinutes() : undefined
    }

    set duration(duration) {
        if (typeof duration !== 'number') {
            throw Error('Duration must be an integer')
        } else if (duration <= 0) {
            throw Error('Duration must be greater than 0!')
        }
        // the duration param is in minutes
        this._duration = moment.duration(duration, 'minutes')
    }

    get endDate() {
        if (this._startDate && this._duration) {
            return this.startDate.clone().add(this._duration)
        } else {
            return undefined
        }
    }

    set endDate(endDate) {
        if (!moment.isMoment(endDate) || !endDate.isValid()) {
            throw Error(endDate + ' is not a valid moment instance!')
        } else if (this._startDate === undefined && this._duration === undefined) {
            throw Error('You must set a startDate or duration before setting an endDate')
        } else if (this._startDate === undefined && this._duration !== undefined) {
            // edge case of setting duration then endDate, but not startDate
            this.startDate = endDate.clone().subtract(this._duration)
        } else if (endDate.unix() < this._startDate.unix()) {
            throw Error('End date must be later than this event\'s start date: ' + this._startDate.format('YYYY-MM-DD HH:mm'))
        } else {
            this._duration = moment.duration(endDate.diff(this._startDate))
        }
    }

    get viewComponent() {
        return this._viewComponent
    }

    set viewComponent(viewComponent) {
        if (viewComponent instanceof HTMLElement || viewComponent instanceof jquery) {
            this._viewComponent = viewComponent
        } else {
            throw Error('viewComponent must be an HTMLElement or jQuery Object')
        }
    }

    get style() {
        return this._style
    }
    
    set style(style) {
        if (typeof style !== "string") {
            throw Error('style must be a string!')
        }
        this._style = style
    }

    get fixed() {
        return this._fixed
    }
    
    set fixed(fixed) {
        if (typeof fixed !== "boolean") {
            throw Error('fixed must be a boolean!')
        }
        this._fixed = fixed
    }

    getDefaultViewComponent(dateText) {
        if (dateText === undefined) {
            dateText = this.startDate.format('h:mm A')
        }else if (typeof dateText !== 'string') {
            throw Error(`dateText must be a string, ${typeof dateText} given`)
        }
        const viewComponent = document.createElement('div')
        
        const startDate = document.createElement('span')
        startDate.className = 'start-date'
        startDate.textContent = dateText
        viewComponent.appendChild(startDate)
        const br = document.createElement('br')
        viewComponent.appendChild(br)
        if (this.type) {
            const typeSpan = document.createElement('span')
            typeSpan.className = `whale-type ${this.type}`
            typeSpan.textContent = `${this.type}: `
            viewComponent.appendChild(typeSpan)
        }


        const title = document.createElement('span')
        title.className = 'title'
        title.textContent = this.title
        viewComponent.appendChild(title)

        return viewComponent
    }

    isValid() {
        if (moment.isMoment(this.startDate) && typeof this.title === "string" && moment.isDuration(this._duration)) {
            return true
        }
        return false
    }
}
